import ParametersTemplate from './parameters.html';

export default angular
  .module('main.devices.edit.tabs.parameters', [])

  .directive('editDeviceParametersTab', () => {
    return {
      restrict: 'E',
      template: ParametersTemplate,
      scope: {},
      controller: ($scope,
                   $rootScope,
                   $q,
                   $filter,
                   utils,
                   I18nService,
                   EditDeviceDataProvider,
                   ToastsService) => {
        const $t = $filter('translate');
        $scope.dataProvider = EditDeviceDataProvider.instance;
        $scope.locale = I18nService.getLocale();

        const DEVICE_FW_UPDATE_ATTR = 'fwUpdate';
        const CURRENT_ORG_LOCAL_STORAGE_KEY = 'Organizations-Current';

        // Supporting all types except push button, complex sliders, datetime, and multi-selects
        const SUPPORTED_DISPLAY_TYPES = [1, 10, 11, 2, 20, 21, 5, 50, 51, 7, 70];

        angular.extend($scope, {
          parameterValueToStr: parameterValueToStr,
          onDeviceParameterClick: onDeviceParameterClick,
          getDeviceParameterIcon: getDeviceParameterIcon,
          manageDeviceFirmware: manageDeviceFirmware,
          changeFirmwareGroup: changeFirmwareGroup,
          onParameterConfigClick: onParameterConfigClick,
          copyToClipboard: $rootScope.copyToClipboard,
        });

        init();

        function init() {
          $scope.loading = true;
          const orgInfo = utils.getStorageItem(CURRENT_ORG_LOCAL_STORAGE_KEY);
          $scope.hasFeatureK = utils.hasFeature(orgInfo, 'k');

          $q.all([
            $scope.dataProvider.deviceCurrentMeasurementsResource.init(),
            $scope.dataProvider.deviceParametersResource.init(),
            $scope.dataProvider.deviceModelResource.init(),
            $scope.dataProvider.deviceResource.init(),
            $scope.dataProvider.deviceLocationResource.init(),
            $scope.dataProvider.deviceTypeResource.init(),
            $scope.dataProvider.firmwareGroupsResource.init(),
          ])
            .then(() => {
              $scope.loading = false;
              initWatchers();
            }, (err) => {
              $scope.loading = false;
              utils.handleApiError(err);
            });

          $scope.$on('$destroy', () => {
            // Remove modals
            $('#manage-firmware-modal').remove();
            $('#param-config-modal').remove();
          });

          $.fn.form.settings.rules.phoneCode = function(value) {
            if (!!$scope.selectedParam?.phoneInfo?.phoneNumber || !!$scope.selectedParam?.phoneInfo?.phoneCode) {
              if (!$scope.selectedParam.phoneInfo.phoneCode || $scope.selectedParam.phoneInfo.phoneCode === '0' || !/^[0-9]{1,3}$/gi.test($scope.selectedParam.phoneInfo.phoneCode)) {
                return false;
              }
            }
            return true;
          };

          $.fn.form.settings.rules.phoneNumber = function(value) {
            if (!!$scope.selectedParam?.phoneInfo?.phoneNumber || !!$scope.selectedParam?.phoneInfo?.phoneCode) {

              if (!$scope.selectedParam.phoneInfo.phoneNumber || !/^[0-9]{7,14}$/gi.test($scope.selectedParam.phoneInfo.phoneNumber)) {
                return false;
              }
            }
            return true;
          };

          $('#param-config-form').form({
            on: 'blur',
            inline: true,
            revalidate: true,
            keyboardShortcuts: false,
            fields: {
              'textString': {
                rules: [
                  {
                    type: 'maxLength[48]',
                    prompt: $t('prompt.params.text')
                  }
                ]
              },
              'phoneCode': {
                depends: 'phoneNumber',
                rules: [
                  {
                    type: 'phoneCode',
                    prompt: $t('prompt.signup.phone.code')
                  }
                ]
              },
              'phoneNumber': {
                identifier: 'phoneNumber',
                rules: [
                  {
                    type: 'phoneNumber',
                    prompt: $t('prompt.signup.phone.invalid')
                  }
                ]
              },
              'sliderValue': {
                rules: [
                  {
                    type: 'empty',
                    prompt: $t('prompt.empty')
                  },
                  {
                    type: 'integer',
                    prompt: $t('prompt.params.integer')
                  }
                ]
              }
            }
          });
        }

        function initWatchers() {
          $scope.$watchGroup([
            'dataProvider.deviceCurrentMeasurementsResource.value',
            'dataProvider.deviceResource.value',
          ], () => {
            initViewModel();
          });

          $scope.$watchGroup([
            'selectedParam.phoneInfo.phoneCode',
            'selectedParam.phoneInfo.phoneNumber',
          ], (newValue, oldValue) => {
            if (newValue !== oldValue) {
              triggerFormValidation();
            }
          });
        }

        function initViewModel() {
          let deviceMeasurementsInfo = angular.copy($scope.dataProvider.deviceCurrentMeasurementsResource.value);
          let deviceTypeInfo = angular.copy($scope.dataProvider.deviceTypeResource.value);
          $scope.location = angular.copy($scope.dataProvider.deviceLocationResource.value);
          $scope.device = angular.copy($scope.dataProvider.deviceResource.value);

          // Firmware update groups
          $scope.firmwareGroups = angular.copy($scope.dataProvider.firmwareGroupsResource.value);
          if ($scope.firmwareGroups && $scope.firmwareGroups.length > 0 && $scope.device.fwGroupId) {
            let currentGroup = $scope.firmwareGroups.find(el => el.groupId === $scope.device.fwGroupId);
            $scope.selectedFirmwareGroupId = currentGroup && currentGroup.groupId;
          }

          // Device type bindings
          if (deviceTypeInfo && deviceTypeInfo.attributes) {
            let firmwareAttr = deviceTypeInfo.attributes.find(el => el.name === DEVICE_FW_UPDATE_ATTR);
            $scope.dataProvider.isFirmwareUpgradable = firmwareAttr && firmwareAttr.value === '1';
          }

          // Flash parameter if changed
          if ($scope.deviceMeasurements && deviceMeasurementsInfo.parameters?.length > 0) {
            deviceMeasurementsInfo.parameters.forEach((param, index) => {
              param.updated = !utils.compareObjects(param, $scope.deviceMeasurements[index], [
                'value',
                'lastUpdateTimeMs'
              ]);
              param.recent = !!$scope.deviceMeasurements[index]?.updated && !param.updated;
            });
          }

          processParameters(deviceMeasurementsInfo?.parameters || []);

          // Location timezone setup
          const useLocationTimezone = !!$scope.location.timezone && !!moment.tz.zone($scope.location.timezone.id);
          if (useLocationTimezone) {
            // Ff location timezone defined and correct - use it
            $scope.timezone = $scope.location.timezone.id;
          } else {
            // if no location timezone is present - use local timezone
            $scope.timezone = moment.tz.guess();
          }
          $scope.timezone = $scope.timezone || 'GMT'; // Just in case
          $scope.timezoneShift = moment.tz($scope.timezone).format('Z');
        }

        /**
         * Enrich device measurements with additional info
         * from parameters notation and device model "displayInfo"
         */
        function processParameters(deviceMeasurements) {
          let deviceModel = angular.copy($scope.dataProvider.deviceModelResource.value);
          let deviceParams = angular.copy($scope.dataProvider.deviceParametersResource.value);

          // Refreshable parameters
          if (deviceModel && deviceModel.displayInfo) {
            $scope.dataProvider.isRefreshableParams = deviceModel.displayInfo.refreshable;
            $scope.dataProvider.refreshableParams = $scope.dataProvider.isRefreshableParams && deviceModel.displayInfo.parameters
              ? deviceModel.displayInfo.parameters.filter(el => el.refresh && {
                name: el.name,
                refresh: true,
              })
              : [];
          }

          $scope.deviceParamsMap = deviceParams.reduce((acc, p) => {
            if (p.name) {
              p = angular.copy(p);
              acc[p.name] = p;

              // Merge display info from device parameter and device model
              if (deviceModel && deviceModel.displayInfo) {
                let deviceModelDisplayInfo = deviceModel.displayInfo.parameters
                  ? deviceModel.displayInfo.parameters.find(param => param.name === p.name)
                  : {};
                p.displayInfo = angular.extend(p.displayInfo || {}, deviceModelDisplayInfo);

                // Update historical-only parameters from device model
                p.historicalOnly = deviceModel.displayInfo.historicalParams
                  ? deviceModel.displayInfo.historicalParams.some(param => param.name === p.name)
                  : false;
              }
            }
            return acc;
          }, {});

          deviceMeasurements.forEach(param => {
            param.mlName = $scope.deviceParamsMap[param.name]?.displayInfo?.mlName ? $scope.deviceParamsMap[param.name]?.displayInfo?.mlName[$scope.locale.code] : param.name;
            param.configured = $scope.deviceParamsMap[param.name]?.displayInfo?.configured === false ? $scope.deviceParamsMap[param.name].displayInfo.configured : !!$scope.deviceParamsMap[param.name].configured;

            // Add index to params with same name
            if (deviceMeasurements.some(dp => dp.name === param.name && dp !== param)) {
              if (param.index != null) {
                param.showIndex = true;
              }
            }
          });

          // Allow params configuration only if organization feature 'k' is enabled
          if ($scope.hasFeatureK) {
            $scope.deviceMeasurements = deviceMeasurements.filter(param => !param.configured);
            $scope.configuredDeviceMeasurements = deviceMeasurements.filter(param => param.configured);
          } else {
            $scope.deviceMeasurements = deviceMeasurements;
          }

          // Filter historical-only parameters
          $scope.historicalDeviceMeasurements = Object.keys($scope.deviceParamsMap).reduce((acc, key) => {
            if ($scope.deviceParamsMap[key].historicalOnly) {
              acc.push($scope.deviceParamsMap[key]);
            }
            return acc;
          }, []);
        }

        function onDeviceParameterClick(paramMeasurement) {
          if (!paramMeasurement) {
            return;
          }
          let param = $scope.deviceParamsMap[paramMeasurement.name];
          if (!param || !param.historical) {
            return;
          }
          $scope.dataProvider.currentHistoryParam = param;
          $scope.dataProvider.currentHistoryParamIndex = paramMeasurement.index;
          $scope.dataProvider.activeTab = 'measurements';
        }

        function parameterValueToStr(parameter, value, index) {
          return utils.deviceParameterToString(parameter, value, index, $scope.locale.code);
        }

        function getDeviceParameterIcon(parameter, value) {
          return utils.getDeviceParameterIcon(parameter, value);
        }

        function manageDeviceFirmware() {
          if ($scope.loading) {
            return;
          }

          $('#manage-firmware-modal').modal({
            autofocus: false,
            closable: false,
          }).modal('show');

          // TODO(max): Depends on admin permissions
          // redirect to 'firmware' tab to manage firmware jobs and versions
          // $scope.dataProvider.activeTab = 'firmware';
        }

        function changeFirmwareGroup() {
          $scope.loading = true;

          $scope.dataProvider.updateDeviceFirmwareGroup($scope.selectedFirmwareGroupId)
            .then(() => {
              $scope.loading = false;
            }, (err) => {
              utils.handleApiError(err);
              $scope.loading = false;
            });
        }

        function triggerFormValidation() {
          if (!!$scope.selectedParam) {
            $('#param-config-form').form('validate form');
          }
        }

        function clearFormErrors() {
          $('#param-config-form .field.error').removeClass('error');
          $('#param-config-form .ui.basic.red.pointing').remove();
        }

        function onParameterConfigClick(parameter) {
          if ($scope.loading || !$scope.dataProvider.isDeviceConnected) {
            return;
          }

          let fieldNames = ['textString'];
          let displayInfo = $scope.deviceParamsMap[parameter.name]?.displayInfo;
          if (!displayInfo || !displayInfo.displayType || !displayInfo.valueType || !SUPPORTED_DISPLAY_TYPES.includes(displayInfo.displayType)) {
            return ToastsService.warning($t('devices.measurements.configUnsupported'));
          }

          // Parse on/off parameter values
          if (displayInfo.displayType === 10 || displayInfo.displayType === 11) {
            fieldNames = [];
            parameter.value = parameter.value === '1' || parameter.value === true ? true : false;
          }

          // Parse phone number
          if (displayInfo.displayType === 51 && !!parameter.value) {
            fieldNames = ['phoneNumber', 'phoneCode'];
            parameter = {
              ...parameter,
              phoneInfo: utils.parsePhoneNumber(parameter.value),
            }
          }

          // Parse selection options
          if (displayInfo.displayType === 2 || displayInfo.displayType === 20 || displayInfo.displayType === 21) {
            fieldNames = [];
            if (displayInfo.options && displayInfo.options.length > 0) {
              let selectedOption = displayInfo.options.find(option => option.value === parameter.value);
              parameter = {
                ...parameter,
                options: displayInfo.options.map(item => ({
                  id: item.id,
                  text: item.mlName[$scope.locale.code]
                })),
                selectedOptionKey: selectedOption ? selectedOption.id : displayInfo.options[0],
              };
            }
          }

          // Parse slider value
          if (displayInfo.displayType === 7 || displayInfo.displayType === 70) {
            fieldNames = ['sliderValue'];
            parameter = {
              ...parameter,
              sliderValue: parseFloat(parameter.value),
            };
          }

          $scope.selectedParam = {
            ...parameter,
            displayInfo: displayInfo,
          };

          $('#param-config-modal').modal({
            autofocus: false,
            closable: false,
            onShow: () => {
              clearFormErrors();
            },
            onApprove: () => {
              // Validate form only for non boolean types
              if (fieldNames && fieldNames.length > 0) {
                triggerFormValidation();
                fieldNames.forEach(fieldName => {
                  if (!$('#param-config-form').form('is valid', fieldName)) {
                    return false;
                  }
                });
              }
              return updateParamMeasurement($scope.selectedParam);
            },
          }).modal('show');
        }

        function updateParamMeasurement(param) {
          // Process boolean parameter values
          if (param.displayInfo.displayType === 10 || param.displayInfo.displayType === 11) {
            param.value = param.value ? '1' : '0';
          }
          // Process selection parameter values
          if (param.displayInfo.displayType === 2 || param.displayInfo.displayType === 20 || param.displayInfo.displayType === 21) {
            let selectedOption = param.displayInfo.options.find(option => option.id === param.selectedOptionObject.id);
            param.value = selectedOption.value;
          }
          // Process slider parameter values
          if (param.displayInfo.displayType === 7 || param.displayInfo.displayType === 70) {
            param.value = param.sliderValue;
          }
          // Process phone number parameter values
          if (param.displayInfo.displayType === 51 && !!param.phoneInfo) {
            param.value = param.phoneInfo.phoneCode + param.phoneInfo.phoneNumber;
          }

          let command = {
            params: [
              {
                name: param.name,
                value: param.value,
              }
            ]
          };

          if (param.index !== undefined) {
            command.params[0].index = param.index;
          }

          $scope.dataProvider.updateDeviceParameter(command)
            .then(() => {
              $scope.selectedParam = void 0;
            }, (err) => {
              utils.handleApiError(err);
            });
        }
      }
    };
  })
  .name;
